import Image from "next/image";
import { Box } from "@mui/system";
import { getTopLevelDomain } from "@/core/utils";
import { Brand, Domains, LegalArea, MediaLogo } from "@/core/types/types";
import getMediaLogosForBrand from "./getMediaLogoForBrand";

type MediaLogosProps = {
  brandName: Brand;
  legalArea: LegalArea;
};

const TLD: Domains | string = getTopLevelDomain() || Domains.NET;

export default function MediaLogos({ brandName, legalArea }: MediaLogosProps) {
  const {
    align = "flex-start",
    logos,
    gap,
  }: {
    align: string;
    logos: MediaLogo[];
    gap?: number;
  } = getMediaLogosForBrand(
    brandName,
    legalArea,
    Object.values(Domains).includes(TLD as Domains)
      ? (TLD as Domains)
      : Domains.NET
  );

  return (
    <Box display="flex" flexDirection="column" alignItems={align} gap={gap}>
      {logos.map(({ logo, width, height }) => (
        <Image
          key={logo}
          src={`images/logos/${brandName}/media/${logo}`}
          alt="media logo"
          height={height || 40}
          width={width || 180}
        />
      ))}
    </Box>
  );
}
